import { type Nullable } from '@hooks-api/types/nullable'

export const getErrorContent = (content: Nullable<Record<string, string[]>[] | string[]>) => {
  if (!content || content.length === 0) return ''
  /** 逐項判斷型別，避免陣列混雜 string 與 object 時被 content[0] 誤判成單一型別 */
  return content.flatMap((item) => {
    if (typeof item === 'string') return item
    return Object.entries(item ?? {}).flatMap(([field, messages]) => {
      if (Array.isArray(messages)) return messages.map(message => `「${field}」: ${String(message)}`)
      return [`「${field}」: ${String(messages)}`]
    })
  }).join(', ')
}
